import React, { useState, useEffect } from "react";
import ImageSlider from "./ImageSlider";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1000,
    margin: "0 auto",
    backgroundColor: `${theme.palette.secondary.main}`,
  },
}));

const Gallery = ({ imageNames }) => {
  const classes = useStyles();
  const [images, setImages] = useState([]);

  useEffect(() => {
    Promise.all(
      imageNames.map((imageName) =>
        import(`./images/${imageName}`).then((module) => module.default)
      )
    ).then((loadedImages) => setImages(loadedImages));
  }, [imageNames]);

  return (
    <div className={classes.root}>
      <ImageSlider images={images} />
    </div>
  );
};

export default Gallery;
